import { render, staticRenderFns } from "./RecCookie.vue?vue&type=template&id=5c4e2012&scoped=true&"
import script from "./RecCookie.vue?vue&type=script&lang=js&"
export * from "./RecCookie.vue?vue&type=script&lang=js&"
import style0 from "./RecCookie.vue?vue&type=style&index=0&id=5c4e2012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e2012",
  null
  
)

export default component.exports